import { useCurrentUser } from 'api/authentication/hooks';

import { MAX_VISIBLE_PRESENCE_AVATARS } from './constants';
import { usePresence } from './presence-context';
import { UserAvatarList } from './user-avatar-list';

export const JourneyPresenceIndicator = () => {
  const { activeUsers } = usePresence();
  const currentUser = useCurrentUser();
  if (!currentUser) {
    return null;
  }

  const currentUserId = currentUser.shortId;
  const otherUsers = activeUsers.filter((user) => user.userId !== currentUserId.toString());

  return (
    <UserAvatarList
      users={otherUsers}
      maxVisible={MAX_VISIBLE_PRESENCE_AVATARS}
      tooltipPlacement="left"
    />
  );
};
